import React from 'react';
function SortByAscendingOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 18L3 16L21 16L21 18L3 18ZM3 6L9 6L9 8L3 8L3 6ZM15 11L3 11L3 13L15 13L15 11Z" })));
}
export default SortByAscendingOutlined;
